module.exports = __webpack_public_path__ + "media/images/worktype_role/responsable-353a721c13aed917e6f542df0b9bafd8.png";